import {
  Box,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Skeleton,
  Link as MuiLink,
} from '@mui/material';
import CameraImage from 'components/CameraImage';
import React from 'react';
import { Camera } from 'types/Camera';
import CamerasCarouselPagination from './CamerasCarouselPagination';
import { Link } from 'react-router-dom';

const ROW_HEIGHT = 231;
function CamerasCarousel({
  cameras,
  refetchCamerasList,
}: {
  cameras: Camera[];
  refetchCamerasList: () => void;
}) {
  const [page, setPage] = React.useState(0);
  const rowsPerPage = 4;

  const [hovering, setHovering] = React.useState(false);

  const countPage = React.useMemo(
    () => Math.max(0, Math.ceil(cameras.length / rowsPerPage)),
    [cameras, rowsPerPage],
  );

  return (
    <Box onMouseOver={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
      <ImageList
        rowHeight={ROW_HEIGHT}
        sx={{
          flex: '1 1 auto',
          height: ROW_HEIGHT * 2 + 8,
          position: 'relative',
          overflow: 'visible',
        }}
      >
        {cameras.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((camera) => (
          <ImageListItem key={camera.name}>
            <MuiLink
              component={Link}
              to={`/cameras/${camera.name}`}
              sx={{
                display: 'flex',
                flex: '1 1 auto',
                textDecoration: 'none',
              }}
            >
              <CameraImage
                snapUrl={camera.snapUrl}
                alt={camera.name}
                token={camera.token}
                refetchCamerasList={refetchCamerasList}
              />
              <ImageListItemBar
                title={camera.name}
                sx={{
                  borderBottomLeftRadius: '4px',
                  borderBottomRightRadius: '4px',
                }}
              />
            </MuiLink>
          </ImageListItem>
        ))}
        <CamerasCarouselPagination.NavigateBefore {...{ page, setPage, hovering }} />
        <CamerasCarouselPagination.NavigateNext {...{ page, setPage, hovering, countPage }} />
      </ImageList>
      <CamerasCarouselPagination
        {...{
          page,
          setPage,
          rowsPerPage,
          countPage,
        }}
      />
    </Box>
  );
}

CamerasCarousel.Loading = function Loading() {
  return (
    <ImageList
      rowHeight={ROW_HEIGHT}
      sx={{
        flex: '1 1 auto',
        height: ROW_HEIGHT * 2 + 8,
        position: 'relative',
        overflow: 'visible',
      }}
    >
      {Array.from({ length: 4 }).map((_, index) => (
        <ImageListItem key={index}>
          <CameraImage.Loading />
          <ImageListItemBar
            title={<Skeleton />}
            sx={{
              borderBottomLeftRadius: '4px',
              borderBottomRightRadius: '4px',
            }}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
};

export default CamerasCarousel;
